import Layout from '~componentes/LayoutEditais.vue';
import ListaEditais from './componentes/compartilhado/ListaEditais.vue';
import DetalharEdital from './componentes/compartilhado/DetalharEdital.vue';


export default {
  path: '/editais',
  component: Layout,
  children: [
    {
      path: '',
      component: ListaEditais,
      name: 'editais',
    },
    {
      path: ':id',
      component: DetalharEdital,
      name: 'editais.detalhar',
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/edital/rotas.js